import React from 'react';
import { QuestionOrdering } from '@scormhero/shared';

import { onChangePayload } from '../Matching/Matching';
import Ordering from './Ordering';

type OrderingWrapperProps = {
  question: QuestionOrdering;
  tracking: any;
  config: any;
  onChange: Function;
};

function OrderingWrapper(props: OrderingWrapperProps) {
  const { question, tracking, config, onChange } = props;
  const { showCorrectAnswer, showYourAnswers } = config;
  const { answer, submitted } = tracking;

  function handleOnChange(payload: onChangePayload) {
    onChange &&
      onChange(undefined, {
        value: payload.completed ? payload : undefined, // to avoid submit when incomplete
        questionId: question.resourceId,
      });
  }

  return (
    <div style={{ marginTop: '10px' }}>
      <Ordering
        orderingItems={question?.orderingItems}
        orderingResponse={submitted ? answer?.response : undefined}
        onChange={handleOnChange}
        showFeedback={submitted && (showCorrectAnswer || showYourAnswers)}
        disabled={submitted}
      />
    </div>
  );
}

export default OrderingWrapper;
